export default "__VITE_ASSET__332ce2d9__"